
import { Risolto_Communication_Template } from '@/generated/graphql';
import gql from 'graphql-tag';
import Vue from 'vue';

const componentsDialogsAttachmentTemplatesDialog__templates = gql`
query componentsDialogsAttachmentTemplatesDialog__templates ($participant: uuid!) {
  templates: risolto_communication_template(
    where:{
      participant: { _eq: $participant }
      ui_template_configuration: { _is_null: false }
    }
  ) {
    template_id
    channel
    document_name
    locale
    legal_entity
    participant
    subject_template
    template_query
    template_renderer_version
    ui_template_configuration
  }
}
`;

export default Vue.extend({
	data() {
		return {
			// Private variables
			visible: false,
			resolvePromise: undefined,
			rejectPromise: undefined
		};
	},
	apollo: {
		templates: {
			query: componentsDialogsAttachmentTemplatesDialog__templates,
			variables() {
				return {
					participant: this.$store.state.risolto.selectedParticipantStore
				};
			}
		}
	},
	methods: {
		show() {
			// Once we set our config, we tell the popup modal to open
			this.visible = true;
			// Return promise so the caller can get results
			return new Promise((resolve, reject) => {
				this.resolvePromise = resolve;
				this.rejectPromise = reject;
			});
		},

		handleChooseTemplate(template: Risolto_Communication_Template) {
			this.visible = false;
			this.resolvePromise(template);
		},

		handleClose() {
			this.visible = false;
			this.resolvePromise(null);
		}
	}
});
